import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Pagination } from 'antd';
import { PAGE_SIZE } from 'enums/table-enums';
import { FONTS } from 'styles/theme/fonts';
import { COLORS } from 'styles/theme/colors';

export const PaginationComponent = ({ changePage, tableData, tableLabel }) => {
  return (
    <PaginationComponent.PaginationContainer>
      <PaginationComponent.ItemLabel>{tableLabel}</PaginationComponent.ItemLabel>
      <Pagination
        total={tableData.total}
        current={tableData.current}
        simple
        pageSize={PAGE_SIZE}
        onChange={(page) => changePage(page)}
      />
    </PaginationComponent.PaginationContainer>
  );
};

PaginationComponent.PaginationContainer = styled.div`
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
`;

PaginationComponent.ItemLabel = styled.div`
  position: absolute;
  left: 40px;
  font-size: 16px;
  font-family: ${FONTS.default};
  color: ${COLORS.secondaryText};
`;

PaginationComponent.propTypes = {
  changePage: PropTypes.func.isRequired,
  tableData: PropTypes.shape({
    total: PropTypes.number,
    current: PropTypes.number,
  }),
  tableLabel: PropTypes.string,
};

export default PaginationComponent;
